import React, { useState,useRef } from 'react';
import { FaAddressCard, FaUser,FaCheckCircle,FaFileAlt } from 'react-icons/fa'; 
import { Container,  Form } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";


const SignUpLayer = () => {
  const [showRegulatoryBodyInput, setShowRegulatoryBodyInput] = useState(false);
  const [showSeniorManagementInput, setShowSeniorManagementInput] = useState(false);
  const [showExternalAuditorInput, setShowExternalAuditorInput] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [isChecked4, setIsChecked4] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const steps = [
    { name: 'Company Info', icon: <FaAddressCard /> },
    { name: 'Contact Info', icon: <FaUser /> },
    { name: 'KYC Documents', icon: <FaFileAlt /> },
    { name: 'Declaration', icon: <FaCheckCircle /> },
  ];
  const navigate = useNavigate();
  const [errors, setErrors] = useState({}); 

  // Form Refs
  const formRefs = {
    institutionName: useRef(),
    companyLegalStatus: useRef(),
    country: useRef(),
    registrationNumber: useRef(),
    date: useRef(),
    registeringAuthority: useRef(),
    businessActivity: useRef(),
    annualTurnover: useRef(),
    typeOfProfile: useRef(),
    accountType: useRef(),
    natureOfAccount: useRef(),
    anticipatedVolume: useRef(),
    sourceOfFunds: useRef(),
    purpose: useRef(),
    noOfEmployees: useRef(),
    Address1: useRef(),
    Address2: useRef(),
    telephone: useRef(),
    fax: useRef(),
    email: useRef(),
    password: useRef(),
    website: useRef(),
    commercialRegistration: useRef(),
    vatCertificate: useRef(),
    companyRegistration: useRef(),
    authorisedSignatory: useRef(),
    memorandumAssociation: useRef(),
    articleAssociation: useRef(),
    partnershipAgreement: useRef(),
    boardResolution: useRef(),
    listOfSignatories: useRef(),
    financialReport: useRef(),
    date1: useRef(),
    signature: useRef()
    };

    const validateCurrentStep = () => {
      const currentErrors = {};
    
      if (currentStep === 0) {
        if (!formRefs.institutionName.current?.value.trim()) {
          currentErrors.institutionName = "Institute name is required.";
        }
        if (!formRefs.companyLegalStatus.current?.value.trim()) {
          currentErrors.companyLegalStatus = "Company legal status is required.";
        }
        if (!formRefs.country.current?.value.trim()) {
          currentErrors.country = "Country is required.";
        }
        if (!formRefs.registrationNumber.current?.value.trim()) {
          currentErrors.registrationNumber = "Registration number is required.";
        }
        if (!formRefs.date.current?.value) {
          currentErrors.date = "Date is required.";
        }
        if (!formRefs.registeringAuthority.current?.value.trim()) {
          currentErrors.registeringAuthority = "Registering authority is required.";
        }
        if (!formRefs.businessActivity.current?.value.trim()) {
          currentErrors.businessActivity = "Business activity is required.";
        }
        if (!formRefs.annualTurnover.current?.value.trim()) {
          currentErrors.annualTurnover = "Annual turnover is required.";
        }
        if (!formRefs.typeOfProfile.current?.value.trim()) {
          currentErrors.typeOfProfile = "Type of profile is required.";
        }
        if (!formRefs.accountType.current?.value.trim()) {
          currentErrors.accountType = "Account type is required.";
        }
        if (!formRefs.natureOfAccount.current?.value.trim()) {
          currentErrors.natureOfAccount = "Nature of account is required.";
        }
        if (!formRefs.anticipatedVolume.current?.value.trim()) {
          currentErrors.anticipatedVolume = "Anticipated volume is required.";
        }
        if (!formRefs.sourceOfFunds.current?.value.trim()) {
          currentErrors.sourceOfFunds = "Source of funds is required.";
        }
        if (!formRefs.purpose.current?.value.trim()) {
          currentErrors.purpose = "Purpose is required.";
        }
        if (!formRefs.noOfEmployees.current?.value.trim()) {
          currentErrors.noOfEmployees = "Number of employees is required.";
        }
      } else if (currentStep === 1) {
        if (!formRefs.Address1.current?.value.trim()) {
          currentErrors.Address1 = "Address line 1 is required.";
        }
        
        if (!formRefs.telephone.current?.value.trim()) {
          currentErrors.telephone = "Telephone is required.";
        }
        
        if (!formRefs.email.current?.value.trim()) {
          currentErrors.email = "Email is required.";
        } else {
          const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailPattern.test(formRefs.email.current.value.trim())) {
            currentErrors.email = "Please provide a valid email address.";
          }
        }
        const passwordValue = formRefs.password.current?.value.trim();
              if (!passwordValue) {
                currentErrors.password = "Password is required.";
              } else if (passwordValue.length < 8) {
                currentErrors.password = "Password must be at least 8 characters.";
              } else if (!/[A-Z]/.test(passwordValue)) {
                currentErrors.password = "Password must include an uppercase letter.";
              } else if (!/[a-z]/.test(passwordValue)) {
                currentErrors.password = "Password must include a lowercase letter.";
              } else if (!/[0-9]/.test(passwordValue)) {
                currentErrors.password = "Password must include a number.";
              } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(passwordValue)) {
                currentErrors.password = "Password must include a special character.";
              }
        if (!formRefs.website.current?.value.trim()) {
          currentErrors.website = "Website Link is required.";
        }
      } else if (currentStep === 2) {
        if (!formRefs.commercialRegistration.current.files?.[0]) {
          currentErrors.commercialRegistration = "Commercial registration file is required.";
        }
        if (!formRefs.vatCertificate.current.files?.[0]) {
          currentErrors.vatCertificate = "VAT certificate file is required.";
        }
        if (!formRefs.companyRegistration.current.files?.[0]) {
          currentErrors.companyRegistration = "Company registration file is required.";
        }
        if (!formRefs.authorisedSignatory.current.files?.[0]) {
          currentErrors.authorisedSignatory = "Authorised Signatory file is required.";
        }
        if (!formRefs.memorandumAssociation.current.files?.[0]) {
          currentErrors.memorandumAssociation = "Memorandum of association is required.";
        }
        if (!formRefs.articleAssociation.current.files?.[0]) {
          currentErrors.articleAssociation = "Article of association is required.";
        }
        if (!formRefs.partnershipAgreement.current.files?.[0]) {
          currentErrors.partnershipAgreement = "Partnership agreement file is required.";
        }
        if (!formRefs.boardResolution.current.files?.[0]) {
          currentErrors.boardResolution = "Board resolution file is required.";
        }
        if (!formRefs.listOfSignatories.current.files?.[0]) {
          currentErrors.listOfSignatories = "List of signatories file is required.";
        }
        if (!formRefs.financialReport.current.files?.[0]) {
          currentErrors.financialReport = "Financial report file is required.";
        }
      }else if (currentStep === 3) {
        if (!isChecked1) {
          currentErrors.declaration1 = "You must confirm the first declaration.";
        }
        if (!isChecked2) {
          currentErrors.declaration2 = "You must confirm the second declaration.";
        }
        if (!isChecked3) {
          currentErrors.declaration3 = "You must confirm the third declaration.";
        }
        if (!isChecked4) {
          currentErrors.declaration3 = "You must confirm the Fourth declaration.";
        }
        
        if (!formRefs.signature.current?.value.trim()) {
          currentErrors.signature = "Signature is required.";
        }
      }
    
      setErrors(currentErrors);
      return Object.keys(currentErrors).length === 0;
    };
    
    const handleNext = () => {
      if (validateCurrentStep()) {
        if (currentStep < steps.length - 1) {
          setCurrentStep(currentStep + 1);
        }
      }
    };

 
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    if (validateCurrentStep()) {
      const formData = {
        institutionName: formRefs.institutionName.current?.value || "",
        companyLegalStatus: formRefs.companyLegalStatus.current?.value || "",
        country: formRefs.country.current?.value || "",
        registrationNumber: formRefs.registrationNumber.current?.value || "",
        date: formRefs.date.current?.value || "",
        registeringAuthority: formRefs.registeringAuthority.current?.value || "",
        businessActivity: formRefs.businessActivity.current?.value || "",
        annualTurnover: formRefs.annualTurnover.current?.value || "",
        typeOfProfile: formRefs.typeOfProfile.current?.value || "",
        accountType: formRefs.accountType.current?.value || "",
        natureOfAccount: formRefs.natureOfAccount.current?.value || "",
        anticipatedVolume: formRefs.anticipatedVolume.current?.value || "",
        sourceOfFunds: formRefs.sourceOfFunds.current?.value || "",
        purpose: formRefs.purpose.current?.value || "",
        noOfEmployees: formRefs.noOfEmployees.current?.value || "",
        address1: formRefs.Address1.current?.value || "",
        address2: formRefs.Address2.current?.value || "",
        telephone: formRefs.telephone.current?.value || "",
        fax: formRefs.fax.current?.value || "",
        email: formRefs.email.current?.value || "",
        password: formRefs.password.current?.value || "",
        website: formRefs.website.current?.value || "",
        commercialRegistration: formRefs.commercialRegistration.current?.files[0]?.name || "Not Uploaded",
        vatCertificate: formRefs.vatCertificate.current?.files[0]?.name || "Not Uploaded",
        companyRegistration: formRefs.companyRegistration.current?.files[0]?.name || "Not Uploaded",
        authorisedSignatory: formRefs.companyRegistration.current?.files[0]?.name || "Not Uploaded",
        memorandumAssociation: formRefs.memorandumAssociation.current?.files[0]?.name || "Not Uploaded",
        articleAssociation: formRefs.articleAssociation.current?.files[0]?.name || "Not Uploaded",
        partnershipAgreement: formRefs.partnershipAgreement.current?.files[0]?.name || "Not Uploaded",
        boardResolution: formRefs.boardResolution.current?.files[0]?.name || "Not Uploaded",
        listOfSignatories: formRefs.listOfSignatories.current?.files[0]?.name || "Not Uploaded",
        financialReport: formRefs.financialReport.current?.files[0]?.name || "Not Uploaded",
        date1: formRefs.date1.current?.value || "",
        declaration1: isChecked1,
        declaration2: isChecked2,
        declaration3: isChecked3,
        declaration4: isChecked4,
        signature: formRefs.signature.current.value ||"",
      };
  
      console.log("Form Data Submitted:", formData);
  
      navigate("/");
    }
  };
  

  return (
    <div id="msform" >
      <div className="custom-navbar">
        <div className="row align-items-center justify-content-between">
         
          <div className="col-auto">
            <div className="d-flex flex-wrap align-items-center">
              
              <div>
                  <Link className='sidebar-logo'>
                    <img
                      src='/assets/images/BlueAsterAR.png'
                      alt='site logo'
                      className='light-logo'
                    />
                    <img
                      src='/assets/images/BlueAsterAR_Reverse.png'
                      alt='site logo'
                      className='dark-logo'
                    />
                    <img
                      src='/assets/images/BlueAsterAR.svg'
                      alt='site logo'
                      className='logo-icon'
                    />
                  </Link>
                </div>
            </div>
          </div>

          
          <div className="col-auto">
            <div className="d-flex flex-wrap align-items-center gap-3">
            <ThemeToggleButton />
            
              <div className="dropdown">
                
                  <Link to="/">
                  <img
                    src="/assets/images/user.png"
                    alt="image_user"
                    
                  />
                  </Link>
                
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Progress Bar */}
      <ul id="progressbar" className="progress-bar d-flex justify-content-around list-unstyled flex-row">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`text-center ${index <= currentStep ? 'active' : ''}`}
            id={step.name.toLowerCase().replace(' ', '')}
            onClick={() => setCurrentStep(index)} 
            style={{ cursor: 'pointer' }} 
          >
            <div className="step-icon mb-1">{step.icon}</div>
            <span>{step.name}</span>
          </li>
        ))}
      </ul>


  {/* Company INFO Fieldsets */}
     <Container className="mt-5" >
        <Form>
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 0 ? "block" : "none", 
              borderRadius: "10px",
              boxShadow: "0px 0px 20px #748292",
              transition: "all 0.5s ease-in-out",
              textAlign:"left"
            }}
           
          >
            <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
              Company Info
            </h6>
            <hr style={{ margin:"5px",border: "1px solid #748292",width: "100%",}}/>

           
            <div className="row mb-3" >
              <label className="col-md-3 col-form-label text-start ">Name of the Institution</label>
              <div className="col-md-9" >
                <input
                  ref={formRefs.institutionName}
                  type="text"
                  className={`form-control shadow-sm ${errors.institutionName ? 'is-invalid' : ''}`}
                  placeholder=""
                  required
                />
                 <div className="invalid-feedback">{errors.institutionName}</div>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Company Legal Status
              </label>
              <div className="col-md-9">
                <select 
                ref={formRefs.companyLegalStatus}
                class={`form-control shadow-sm ${errors.companyLegalStatus ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Single Person Company (SPC)</option>
                  <option>With Limited Liability(WLL)</option>
                  <option>Partnership Company</option>
                  <option>Limited Partnership by Shares</option>
                  <option>Bahraini Shareholding Company(BSC)</option>
                  <option>Bahraini Shareholding Company(BSC Closed)</option>
                  <option>Foreign Company Branch (Company Representative)</option>   
                </select>
                <div className="invalid-feedback">{errors.companyLegalStatus}</div>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Country of Incorporation
              </label>
              <div className="col-md-9">
                <select ref={formRefs.country} className={`form-control shadow-sm ${errors.country ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Afganistan</option>
                  <option>Albania</option>
                  </select>
                  <div className="invalid-feedback">{errors.country}</div>
              </div>
            </div>
 
                
            
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start "> Company Registration Number</label>
              <div className="col-md-9">
                <input
                  type="text"
                  ref={formRefs.registrationNumber}
                  className={`form-control shadow-sm ${errors.registrationNumber ? 'is-invalid' : ''}`}
                  placeholder=""
                />
                <div className="invalid-feedback">{errors.registrationNumber}</div>
              </div>
            </div>

        
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Date of Incorporation
              </label>
              <div className="col-md-9">
                <input type="date" 
                ref={formRefs.date}
                className={`form-control shadow-sm ${errors.date ? 'is-invalid' : ''}`} required />
                <div className="invalid-feedback">{errors.date}</div>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Registering Authority
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  ref={formRefs.registeringAuthority}
                  className={`form-control shadow-sm ${errors.registeringAuthority ? 'is-invalid' : ''}`}
                  placeholder=""
                  required
                />
                <div className="invalid-feedback">{errors.registeringAuthority}</div>
              </div>
            </div>

            
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Business Activity
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  ref={formRefs.businessActivity}
                  className={`form-control shadow-sm ${errors.businessActivity ? 'is-invalid' : ''}`}
                  placeholder=""
                  required
                />
                <div className="invalid-feedback">{errors.businessActivity}</div>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Annual Turnover (US$ Millions)
              </label>
              <div className="col-md-9">
                <select  ref={formRefs.annualTurnover} className={`form-control shadow-sm ${errors.annualTurnover ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Less than 50</option>
                  <option>51-99</option>
                  <option>100-250</option>
                  <option>251-500</option>
                  <option>501-1,000</option>
                  <option>Above 1,000</option>
                  </select>
                  <div className="invalid-feedback">{errors.annualTurnover}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Type of Profile
              </label>
              <div className="col-md-9">
                <select 
                ref={formRefs.typeOfProfile} className={`form-control shadow-sm ${errors.typeOfProfile ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Resident</option>
                  <option>Non-Resident</option>
                  </select>
                  <div className="invalid-feedback">{errors.typeOfProfile}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Type of Account
              </label>
              <div className="col-md-9">
                <select 
                ref={formRefs.accountType}
                className={`form-control shadow-sm ${errors.accountType ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Individual</option>
                  <option>Entity</option>
                  </select>
                  <div className="invalid-feedback">{errors.accountType}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Nature of Account
              </label>
              <div className="col-md-9">
                <select 
                ref={formRefs.natureOfAccount}
                className={`form-control shadow-sm ${errors.natureOfAccount ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Investment in Equities</option>
                  <option>Investment in Securities</option>
                  <option>Investment in Bonds</option>
                  <option>Investment in Commodities</option>
                  <option>Investment in Mutual Funds</option>
                  <option>Investment in Stocks</option>
                  <option>Investment in Digital Assets</option>
                  </select>
                  <div className="invalid-feedback">{errors.natureOfAccount}</div>
              </div>
            </div>
 
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Anticipated Volume
              </label>
              <div className="col-md-9">
                <select 
                ref={formRefs.anticipatedVolume}
                className={`form-control shadow-sm ${errors.anticipatedVolume ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>1 - 100,000 USD</option>
                  <option>100,000 - 500,000 USD</option>
                  <option>500,000 - 1,000,000 USD</option>
                  <option>1,000,000 - 10,000,000 USD </option>
                  <option>10,000,000 - 50,000,000 USD</option>
                  </select>
                  <div className="invalid-feedback">{errors.anticipatedVolume}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Source of Funds
              </label>
              <div className="col-md-9">
                <select 
                ref={formRefs.sourceOfFunds}
                className={`form-control shadow-sm ${errors.sourceOfFunds ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Salary</option>
                  <option>Business Activity</option>
                  <option>Savings</option>
                  <option>Pension </option>
                  <option>Inheritance</option>
                  <option>Gift</option>
                  <option>Bonus</option>
                  <option>Indemnity/End of Service Payment</option>
                  <option>Return of Investment</option>
                  <option>Other</option>
                  </select>
                  <div className="invalid-feedback">{errors.sourceOfFunds}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Purpose And Intended Nature Of The Business Relationship
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  ref={formRefs.purpose}
                  className={`form-control shadow-sm ${errors.purpose ? 'is-invalid' : ''}`}
                  placeholder="NA"
                />
                <div className="invalid-feedback">{errors.purpose}</div>
              </div>
            </div>
              
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
               No. of Employees
              </label>
              <div className="col-md-9">
                <select 
                ref={formRefs.noOfEmployees}
                className={`form-control shadow-sm ${errors.noOfEmployees ? 'is-invalid' : ''}`} required>
                  <option value="">Select</option>
                  <option>Less than 10 Employees</option>
                  <option>11-25 Employees</option>
                  <option>26-50 Employees</option>
                  <option>51-99 Employees</option>
                  <option>100-500 Employees</option>
                  <option>Above 500 Employees</option>
                </select>
                <div className="invalid-feedback">{errors.noOfEmployees}</div>
             </div>
            </div>  
             
            <div className="row mb-3">
            <div className="mb-3 d-flex align-items-start">
              <input
                type="checkbox"
                id="1"
                className="form-check-input me-2"
                checked={showRegulatoryBodyInput}
                onChange={(e) => setShowRegulatoryBodyInput(e.target.checked)}
              />
              <label className="form-check-label">
                Regulatory Body or Listing Body If Applicable
              </label>
            </div>
            {showRegulatoryBodyInput && (
              <div className="mb-3">
                <label htmlFor="regulatoryBodyInput" className="form-label">
                  Enter Regulatory Body Name:
                </label>
                <input
                  type="text"
                  id="regulatoryBodyInput"
                  placeholder=""
                  className="form-control"
                />
              </div>
            )}

            <div className="mb-3 d-flex align-items-start">
              <input
                type="checkbox"
                id="2"
                className="form-check-input me-2"
                checked={showSeniorManagementInput}
                onChange={(e) => setShowSeniorManagementInput(e.target.checked)}
              />
              <label className="form-check-label">
                Names of Relevant Persons in Senior Management If Applicable
              </label>
            </div>
            {showSeniorManagementInput && (
              <div className="mb-3">
                <label htmlFor="seniorManagementInput" className="form-label">
                  Enter Senior Management Names:
                </label>
                <input
                  type="text"
                  id="seniorManagementInput"
                  placeholder=""
                  className="form-control"
                />
              </div>
            )}

            <div className="mb-3 d-flex align-items-start">
              <input
                type="checkbox"
                id="id3"
                className="form-check-input me-2"
                checked={showExternalAuditorInput}
                onChange={(e) => setShowExternalAuditorInput(e.target.checked)}
              />
              <label className="form-check-label">
                Name of External Auditor If Applicable
              </label>
            </div>
            {showExternalAuditorInput && (
              <div className="mb-3">
                <label htmlFor="externalAuditorInput" className="form-label">
                  Enter External Auditor Name:
                </label>
                <input
                  type="text"
                  id="externalAuditorInput"
                  placeholder=""
                  className="form-control"
                />
              </div>
            )}
          </div>

           
          </fieldset>
          </Form>

            

       {/* contact info */}
        <fieldset
          style={{
           textAlign:"left",
           display: currentStep === 1 ? "block" : "none"}}>
           
          <div  style={{
            margin: "10px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 0px 20px #748292",
            transition: "all 0.5s ease-in-out"}} >
              <h6 className="text-start " style={{ marginBottom: "0.7rem" }}>Contact Info</h6>
              <hr  style={{
                border: "1px solid #748292",
                margin: "5px",
                width: "100%",
              }}/>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
              Address(1)
              </label>
              <div className="col-md-9">
                <input
                  ref={formRefs.Address1}
                  className={`form-control shadow-sm ${errors.Address1 ? 'is-invalid' : ''}`}
                  placeholder="Enter the Address 1"
                  required
                />
                <div className="invalid-feedback">{errors.Address1}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
              Address(2)
              </label>
              <div className="col-md-9">
                <input
                  ref={formRefs.Address2}
                  className={`form-control shadow-sm ${errors.Address2 ? 'is-invalid' : ''}`}
                  placeholder="Enter the Address 2"
                  required
                />
                <div className="invalid-feedback">{errors.Address2}</div>
              </div>
            </div>

            <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start">Location</label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control shadow-sm mb-3"
                    placeholder="City *"
                    required
                  />
                  <input
                    type="text"
                    className="form-control shadow-sm mb-3"
                    placeholder="NA"
                    required
                  />
                  <select className="form-select shadow-sm" required>
                    <option value="">Select</option>
                    <option>India</option>
                    <option>Africa</option>
                  </select>
                </div>
              </div>


            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Telephone *</label>
              <div className="col-md-9">
                <input
                  type="tel"
                  ref={formRefs.telephone}
                  className={`form-control shadow-sm ${errors.telephone ? 'is-invalid' : ''}`}
                  placeholder="Enter your telephone number"
                  required
                />
                <div className="invalid-feedback">{errors.telephone}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Fax</label>
              <div className="col-md-9">
                <input
                  type="text"
                  ref={formRefs.fax}
                  className={`form-control shadow-sm ${errors.fax ? 'is-invalid' : ''}`}
                  placeholder="Enter your fax number (if any)"
                />
                <div className="invalid-feedback">{errors.fax}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">E-Mail *</label>
              <div className="col-md-9">
                <input
                  type="email"
                  ref={formRefs.email}
                  className={`form-control shadow-sm ${errors.email ? 'is-invalid' : ''}`}
                  placeholder="Enter your email address"
                  required
                />
                <div className="invalid-feedback">{errors.email}</div>
                </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
                Create Password
              </label>
              <div className="col-md-9">
                <input
                  type="password"
                  ref={formRefs.password}
                  className={`form-control shadow-sm ${errors.password ? 'is-invalid' : ''}`}
                  placeholder=""
                  required
                />
                <div className="invalid-feedback">{errors.password}</div>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
                Website
              </label>
              <div className="col-md-9">
                <input
                  type="password"
                  ref={formRefs.website}
                  className={`form-control shadow-sm ${errors.website ? 'is-invalid' : ''}`}
                  placeholder=""
                  required
                />
                <div className="invalid-feedback">{errors.website}</div>
              </div>
            </div>
          </div>
        </fieldset>





          {/* KYC Documents */}
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 2 ? "block" : "none",
            }}>
            <div
              style={{
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
             
            >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
              KYC Documents
              </h6>
              <hr
                style={{
                  border: "1px solid #748292",
                  margin: "5px",
                  width: "100%",
                }}
              />

              <p className="text-muted text-start mb-4">
                The file size must be under 10 MB and only PDF format is accepted.
              </p>

             
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Commercial Registration
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.commercialRegistration}
                    className={`form-control shadow-sm ${errors.commercialRegistration ? 'is-invalid' : ''}`}
                    accept=".pdf"
                    required
                  />
                  <div className="invalid-feedback">{errors.commercialRegistration}</div>
                </div>
              </div>

             
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                VAT Registration Certificate
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.vatCertificate}
                    className={`form-control shadow-sm ${errors.vatCertificate ? 'is-invalid' : ''}`}
                    accept=".pdf"
                    required
                  />
                  <div className="invalid-feedback">{errors.vatCertificate}</div>
                </div>
              </div>

              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Company Registration Extract
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.companyRegistration}
                    className={`form-control shadow-sm ${errors.companyRegistration ? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.companyRegistration}</div>
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Identification documentation of the Authorised Signatory
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.authorisedSignatory}
                    className={`form-control shadow-sm ${errors.authorisedSignatory ? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.authorisedSignatory}</div>
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Memorandum of Association
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.memorandumAssociation}
                    className={`form-control shadow-sm ${errors.memorandumAssociation ? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.memorandumAssociation}</div>
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Articles of Association
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.articleAssociation}
                    className={`form-control shadow-sm ${errors.articleAssociation ? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.articleAssociation}</div>
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Partnership Agreement
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.partnershipAgreement}
                    className={`form-control shadow-sm ${errors.partnershipAgreement? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.partnershipAgreement}</div>
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Board Resolution
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.boardResolution}
                    className={`form-control shadow-sm ${errors.boardResolution? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.boardResolution}</div>
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                List of Authorized Signatories

                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.listOfSignatories}
                    className={`form-control shadow-sm ${errors.listOfSignatories ? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.listOfSignatories}</div>
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Latest Financial Report and Accounts
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    ref={formRefs.financialReport}
                    className={`form-control shadow-sm ${errors.financialReport ? 'is-invalid' : ''}`}
                    accept=".pdf"
                  />
                  <div className="invalid-feedback">{errors.financialReport}</div>
                </div>
              </div>
            </div>
          </fieldset>

      {/* Declaration */}
      <fieldset
            style={{
              textAlign: "left",
              padding: "20px",
              display: currentStep === 3 ? "block" : "none",
            }}>
            <div
              style={{
                padding: "25px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
            >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Declarations
              </h6>
              <hr
                style={{
                  marginBottom: "0.5rem",
                  width: "100%",
                  border: "1px solid #748292"
                }}
              />

              {/* Declaration Text */}
              <div className="mb-3 d-flex align-items-start">
              <input
                type="checkbox"
                className={`form-check-input me-2 ${errors.declaration1 ? 'is-invalid' : ''}`}
                id="declaration1"
                checked={isChecked1}
                onChange={(e) => setIsChecked1(e.target.checked)}
              />
              <label className="form-check-label" >
              I/We hereby confirm that I/we are acting and would, in future
               will also be acting on my/our behalf for the purpose of transactions, 
               new accounts or providing any further information required by Blue Aster Capital BSC ©.
              </label>
              <div className="invalid-feedback">{errors.declaration1}</div>
            </div>

            <div className="row mb-3">
            
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  className={`form-check-input me-2 ${errors.declaration2 ? 'is-invalid' : ''}`}
                  id="declaration2"
                  checked={isChecked2}
                  onChange={(e) => setIsChecked2(e.target.checked)}
                />
                <label className="form-check-label me-2" >
                  I/We hereby confirm that I/we 
                  are acting on behalf of
                </label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className="form-control shadow-sm"
                  style={{ width: "200px" }} 
                />
              </div>
            </div>



            <div className="mb-3 d-flex align-items-start">
              <input
                type="checkbox"
                className={`form-check-input me-2 ${errors.declaration3 ? 'is-invalid' : ''}`}
                id="declaration3"
                checked={isChecked3}
                onChange={(e) => setIsChecked3(e.target.checked)}
              />
              <label className="form-check-label" >
              I/We hereby confirm the information provided above is true, 
              accurate and complete. Subject to applicable local laws, I/we
               hereby consent for Blue Aster Capital BSC © or any of its affiliates to share our information with domestic or overseas regulators or tax authorities where necessary.
              </label>
              <div className="invalid-feedback">{errors.declaration3}</div>
            </div>

            <div className="mb-3 d-flex align-items-start">
              <input
                type="checkbox"
                className={`form-check-input me-2 ${errors.declaration4 ? 'is-invalid' : ''}`}
                id="declaration4"
                checked={isChecked4}
                onChange={(e) => setIsChecked4(e.target.checked)}
              />
              <label className="form-check-label" >
              I/We agree and undertake to notify Blue Aster Capital BSC © within
               30 calendar days if there is a change in any information which I/we have provided.
              </label>
              <div className="invalid-feedback">{errors.declaration4}</div>
            </div>


             {/* Name / Authorised  Name */}
             <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start">
                  Name / Authorised Signatory Name *
                </label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className={`form-control shadow-sm ${errors.signature ? 'is-invalid' : ''}`}
                    placeholder="Enter your Signature name"
                    ref={formRefs.signature}
                  />
                  <div className="invalid-feedback">{errors.signature}</div>
                </div>
              </div>

              {/* Digital signature */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Digital Signature
                </label>
                <div className="col-md-9">
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "100%",
                      height: "150px",
                      position: "relative",
                    }}>
                    <canvas
                      ref={(canvasRef) => {
                        if (canvasRef) {
                          const ctx = canvasRef.getContext("2d");
                          canvasRef.addEventListener("mousedown", (e) => {
                            ctx.isDrawing = true;
                            ctx.beginPath();
                            ctx.moveTo(e.offsetX, e.offsetY);
                          });

                          canvasRef.addEventListener("mousemove", (e) => {
                            if (ctx.isDrawing) {
                              ctx.lineTo(e.offsetX, e.offsetY);
                              ctx.stroke();
                            }
                          });

                          canvasRef.addEventListener("mouseup", () => {
                            ctx.isDrawing = false;
                          });

                          canvasRef.addEventListener("mouseleave", () => {
                            ctx.isDrawing = false;
                          });
                        }
                      }}
                      width="500"
                      height="150"
                      style={{ width: "100%", height: "100%" }}
                    ></canvas>
                    <button
                      type="button"
                      className="btn btn-danger mt-2"
                      style={{ position: "absolute", bottom: "-40px", right: "0" }}
                      onClick={() => {
                        const canvas = document.querySelector("canvas");
                        const ctx = canvas.getContext("2d");
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>


              {/* Date */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Date *
                </label>
                <div className="col-md-9">
                  <input
                    type="date"
                    className="form-control shadow-sm "
                    ref={formRefs.date1}
                  />
                  
                </div>
              </div>
            </div>
          </fieldset>





      {/* Action buttons */}
      <div className="action-button-container" style={{textAlign:"center"}}>
        <button
          type="button"
          className="action-button-previous"
          onClick={handlePrevious}
          disabled={currentStep === 0}
          style={{ display: currentStep === 0 ? 'none' : 'block' }}
        >
          Previous
        </button>

        
        {currentStep === steps.length - 1 ? (
          <button
            type="button"
            className="action-button"
            onClick={handleSubmit} 
          >
            Submit
          </button>
        ) : (
          <button
            type="button"
            className="action-button"
            onClick={handleNext} >
            Next
          </button>
        )}
      </div>
      </Container>

    </div>
  );
};

export default SignUpLayer;
